var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isVisible)?_c('div',{staticClass:"free-delivery-bar text-center"},[_vm._v(_vm._s(_vm.freeDeliveryText))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }